module.exports = __webpack_public_path__ + "d40910d46c758b96e813b835b1f6512e.png";